import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {getResponseGeneral} from '../../../../../services/getTimeResponseGeneral'
import {getResponseObjective} from '../../../../../services/getResponseObjective'
import moment from 'moment'
import 'moment/locale/es'  
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class ResponseTimeGeneralDay extends Component {
    
    constructor(props) {
        super(props);
        //const begin=moment().subtract(3, 'days')._d
        //const final= moment().subtract(1, "days")._d
            
        this.state = {
            currentObjectiveId: this.props.location.state.fromObjective.objetivo_id,
            loadObjectiveData: false,
            period: this.props.data.period,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'c',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.data.range,
        }  
    }

    static getDerivedStateFromProps(props, state) {
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.statePeriod.startDate).format("Y-MM-DD")){
            return{
                statePeriod:props.data.range,
                isLoading:true,
            }    
        }
        return null
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if (moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.statePeriod.startDate).format("Y-MM-DD")) {
            this.getDataFromAPI();
        }

    }
    

    getDataFromAPI = () => {  
        const { currentObjectiveId,period, statePeriod } = this.state
        const { fromObjective } = this.props.location.state
        const { schedule } = this.props.data
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            // fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            // correccion para que la fecha sea hora local
            fecha_termino = moment(statePeriod.endDate).format().substring(0, 10)
            getResponseGeneral(currentObjectiveId,token,fecha_inicio,fecha_termino,schedule).then(data => {
                if (data.status == 1 || data.status == 5) {
                    localStorage.setItem('isAuthenticated', false);                        
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(data.Objetivo, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino, 
                                schedule)
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            isLoading: false
                        });
                    }
                }  
            })
        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino,schedule) => {
        let lastEventDict = []
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        var tittle=externalData.Objetivo_nombre
        var listStepDays=[]
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        if (schedule == 0){
            externalData.Paso.map(paso=>{
                const groups = paso.rendimientoDetalle.reduce((groups, game) => {
                    var date=parseInt(moment(game.inicio).day())
                    if (!groups[date]) {
                      groups[date] = [];
                    }
                    groups[date].push(game);
                    return groups;
                  }, {});
                var listDays=[]
                Object.keys(groups).map(ele=>{
                    var time=0
                    var time12=0
                    var cont=0
                    var cont12=0
                    groups[ele].map(data=>{
                        var dayTime=parseInt(((((data.inicio).split("T"))[1]).split(":"))[0])
                        if(dayTime===0){
                            time=time+data.respuesta
                            cont=cont+1
                        }
                        if(dayTime===12){
                            time12=time12+data.respuesta
                            cont12=cont12+1
                        }
                    })
                    listDays.push(parseFloat((time/cont).toFixed(2)))
                    listDays.push(parseFloat((time12/cont12).toFixed(2)))
                })
                listStepDays.push({'name':paso.paso_nombre, 'data':listDays, 'marker': {'enabled': true,'radius':2,},})
            })
        } else {
            var listData=[]
            externalData.Paso.map(paso=>{
                paso.estado.map(estado=>{
                    var dictData={}
                    var listDataGroup=[]
                    dictData["paso_nombre"] = estado.paso_nombre
                    
                    Object.keys(estado.rendimientoDetalle).map((index)=>{
                        listDataGroup.push(estado.rendimientoDetalle[index])
                    })
                    dictData["rendimientoDetalle"]=listDataGroup
                    listData.push(dictData)
                })
                
            })
            const result = Object.groupBy(listData, ({ paso_nombre }) => paso_nombre);
            Object.keys(result).map((key) => {
                let arrayData = []
                var nameStep = ""
                Object.keys(result[key]).map((keyData) => {
                    nameStep = result[key][keyData].paso_nombre
                    Object.keys(result[key][keyData].rendimientoDetalle).map((keyDataIndividual) => {
                        arrayData.push(result[key][keyData].rendimientoDetalle[keyDataIndividual])
                    })
                })
                const groups = arrayData.reduce((groups, game) => {
                    var date=parseInt(moment(game.inicio).day())
                    if (!groups[date]) {
                        groups[date] = [];
                    }
                    groups[date].push(game);
                    return groups;
                }, {});
                var listDays=[]
                Object.keys(groups).map(ele=>{
                    var time=0
                    var time12=0
                    var cont=0
                    var cont12=0
                    groups[ele].map(data=>{
                        var dayTime=parseInt(((((data.inicio).split("T"))[1]).split(":"))[0])
                        if(dayTime===0){
                            time=time+data.respuesta
                            cont=cont+1
                        }
                        if(dayTime===12){
                            time12=time12+data.respuesta
                            cont12=cont12+1
                        }
                    })
                    listDays.push(parseFloat((time/cont).toFixed(2)))
                    listDays.push(parseFloat((time12/cont12).toFixed(2)))
                })
                listStepDays.push({'name':nameStep, 'data':listDays, 'marker': {'enabled': true,'radius':2,},})
            })
        }
        
        this.setState({
            chartOptions: {
                // title:"",
                title: {
                    text: '',
                    style: {
                        fontSize: '' 
                     }
                },
                xAxis: {
                    scrollbar: {
                        enabled: true
                    },
                    labels: {
                        formatter: function() {
                            if(!this.value){
                                return '';
                            }
                            var nombre = this.value.split(' ');
                            return '<b>'+nombre[0]+'</b>';
                        },
                    },
                    tickPositions: [0, 2, 4,6, 8,10,12],
                    categories: t('response-time-general-day.chart.xAxis.categories', {returnObjects: true})
                },
                tooltip: {
                    style: { fontSize: '11px' },
                    backgroundColor:'rgba(255,255,255,1)',
                    formatter: function() {
                        return '<b>'+this.series.name+'</b><br/>'+
                               `<b>${t('response-time-general-day.chart.tooltip.text1')}</b> `+ this.x+'<br/>'+
                               `<b>${t('response-time-general-day.chart.tooltip.text2')}</b> `+Highcharts.numberFormat(this.y,2,',')+' [s]';
                    },
                },
                yAxis: {
                    title: {
                        style: { color: '#5A5A5A' },
                        text: t('response-time-general-day.chart.yAxis.title.text')
                    },
                    labels: {
                        formatter: function() {
                            if(this.value % 1 != 0)
                                return this.value.toFixed(2);
                            else
                                return this.value;
                            },
                    },
    
                    gridLineWidth: 0.3,
                    min:0,
                    lineWidth:1,
                },
                
                credits: {
                    enabled: false
                },
                series: listStepDays,
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period
        });

    }
    render() {
        const { dataError, chartOptions, isLoading } = this.state;
        const { t } = this.props;
        if (!dataError) {
            if(isLoading===true){
                return (
                    <PortletContent>
                        <PerfectScrollbar>
                            <Typography
                                variant="h5"
                                >
                                <CircularProgress
                                variant="indeterminate"
                                size={24}
                                thickness={4}                            
                                />
                                <br/>
                                {t('text.loading')}
                            </Typography>
                        </PerfectScrollbar>
                    </PortletContent>
                )
            }else{
                sessionStorage.setItem("chartResponseTimeGeneralDay",JSON.stringify(chartOptions))
                return(
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={chartOptions} 
                    />
                )
            }
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p>Error!</p>)

    }
}


export default compose(withRouter, withTranslation())(ResponseTimeGeneralDay);